import { render } from "./AnalysisCard.vue?vue&type=template&id=0dd49684&scoped=true"
import script from "./AnalysisCard.vue?vue&type=script&lang=js"
export * from "./AnalysisCard.vue?vue&type=script&lang=js"

import "./AnalysisCard.vue?vue&type=style&index=0&id=0dd49684&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd49684"]])

export default __exports__